import { connect } from 'react-redux';
import { ICardTitleEvents } from '../../components/CardTitle/types';
import { ICardTitleHOCProps } from './types';
import { CardTitle } from '../../components/CardTitle/CardTitle';
import { onSave } from './events/onSave';

const mapDispatchToProps = (
    dispatch: any,
    { cardId, setEditing, clickType, setEditingName, onHeightChange, onToggleLoadingImg }: ICardTitleHOCProps,
): ICardTitleEvents => {
    return {
        onSave: (title) => dispatch(onSave(cardId, title, clickType)),
        onHeightChange,
        onToggleLoadingImg,
        setEditing,
        setEditingName,
    };
};

export const CardTitleHOC = connect(
    null,
    mapDispatchToProps
)(CardTitle);

CardTitleHOC.displayName = 'CardTitleHOC';
